import { ReactElement } from "react";
import { Flex, Text, useMantineTheme } from "@mantine/core";
import IconInfoOutline from "@common/components/icons/IconInfoOutline";
import { IInfoCardProps } from "./types";
import IconInfo from "@common/components/icons/IconInfo";
import CustomCard from "../CustomCard";

export default function InfoCard({
  outline,
  children,
  ...customCardProps
}: IInfoCardProps): ReactElement {
  const theme = useMantineTheme();

  return (
    <CustomCard
      borderColor={outline ? "gray.2" : "brand.3"}
      bg={outline ? "gray.1" : "brand.0"}
      maw={theme.breakpoints.sm}
      p="sm"
      withBorder
      {...customCardProps}
    >
      <Flex
        align="flex-start"
        direction="row"
        justify="flex-start"
        wrap="nowrap"
        gap="xs"
      >
        <Flex miw={11} mt={4}>
          {outline ? (
            <IconInfoOutline color={theme.colors.gray[4]} size={14} />
          ) : (
            <IconInfo color={theme.colors.brand[4]} size={14} />
          )}
        </Flex>

        <Text c={outline ? "gray.5" : undefined} fz="sm">
          {children}
        </Text>
      </Flex>
    </CustomCard>
  );
}
